import { ComponentProps, ReactNode } from 'react';
import { Paragraph } from '../../atoms';
import { Container } from './container';

type Props = ComponentProps<typeof Container> & {
  text: string;
};

export function ReadField({ text, ...rest }: Props): ReactNode {
  return (
    <Container {...rest}>
      <Paragraph fontSize="md" fontWeight="500">
        {text}
      </Paragraph>
    </Container>
  );
}
